import React from "react";
import { Box, Grid, Stack, Typography, ButtonBase } from "@mui/material";
import { PremiumCard, dashboardTokens } from "./dashboardStyles";

function HealthPill({ label, count, onClick }) {
  return (
    <ButtonBase
      onClick={count > 0 ? onClick : undefined}
      disabled={count === 0}
      sx={{
        width: "100%",
        justifyContent: "space-between",
        px: 1.75,
        py: 1.25,
        borderRadius: `${dashboardTokens.radius}px`,
        border: `1px solid ${dashboardTokens.border}`,
        backgroundColor: count > 0 ? "#fff" : dashboardTokens.surfaceMuted,
        "&:hover": count > 0 ? { borderColor: "var(--verde, #303926)" } : undefined,
      }}
    >
      <Typography sx={{ fontSize: "0.84rem", color: "#1e1e1e" }}>{label}</Typography>
      <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: count > 0 ? "#1e1e1e" : dashboardTokens.textSecondary }}>
        {count}
      </Typography>
    </ButtonBase>
  );
}

/**
 * Saúde do estoque (problemas em imóveis ATIVOS) + integridade da
 * publicação (/imoveis x /imoveisPublicos). Cada pill com contagem > 0 abre
 * o modal "Precisam de atenção" já filtrado naquele problema.
 */
function PortfolioHealth({ health, integrity, onOpenAttention }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <HealthPill label="Sem fotos" count={health.semFoto.length} onClick={() => onOpenAttention("semFoto")} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <HealthPill label="Sem preço" count={health.semPreco.length} onClick={() => onOpenAttention("semPreco")} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <HealthPill
          label="Sem cidade/bairro"
          count={health.semLocalizacao.length}
          onClick={() => onOpenAttention("semLocalizacao")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <PremiumCard sx={{ height: "100%" }}>
          <ButtonBase
            onClick={integrity.totalIssues > 0 ? () => onOpenAttention("integridade") : undefined}
            sx={{ width: "100%", height: "100%", display: "block", textAlign: "left", p: 1.75 }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography sx={{ fontSize: "0.84rem", color: "#1e1e1e" }}>Integridade da publicação</Typography>
            </Stack>
            <Stack direction="row" spacing={2} sx={{ mt: 0.75 }}>
              <Box>
                <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "#1e1e1e" }}>
                  ✓ {integrity.syncedCount}
                </Typography>
                <Typography sx={{ fontSize: "0.7rem", color: dashboardTokens.textSecondary }}>sincronizados</Typography>
              </Box>
              {integrity.totalIssues > 0 && (
                <Box>
                  <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "#9a6b00" }}>
                    ⚠ {integrity.totalIssues}
                  </Typography>
                  <Typography sx={{ fontSize: "0.7rem", color: dashboardTokens.textSecondary }}>precisam revisão</Typography>
                </Box>
              )}
            </Stack>
          </ButtonBase>
        </PremiumCard>
      </Grid>
    </Grid>
  );
}

export default PortfolioHealth;
